"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const label = (theme) => ({
    fontSize: 14,
    marginBottom: 4,
    display: 'block',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black
});
const colorPaletteWrapper = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: '#EAEAEA',
    padding: 7
};
exports.default = {
    label,
    colorPaletteWrapper
};
